import 'select2';
import Pagination from '../modules/pagination/pagination';

$ = jQuery;

export default class AnalystsTable {
    constructor(el) {
        if (!this.set(el)) return;
        this.init();
    }

    set(el) {
        if (!el) return false;

        this.root = el;
        this.paginationEl = this.root.querySelector('[data-pagination]');
        this.selectEl = this.root.querySelector('[data-select]');
        this.tableWrapper = this.root.querySelector(
            '[data-analysts-table-wrapper]'
        );

        this.postId = this.root.querySelector('input[name="post_id"]').value;
        this.maxPages = this.root.querySelector(
            'input[name="max_pages"]'
        ).value;

        this.selectInstance = null;
        this.paginationInstance = null;
        this.page = 1;
        this.year = null;

        return true;
    }

    init() {
        this.setSelectInstance();
        this.setPagination();
    }

    setSelectInstance() {
        if (!this.selectEl) return false;

        let settings = JSON.parse(this.selectEl.getAttribute('data-settings'));
        settings['dropdownCssClass'] = 'no-search';
        settings['allowClear'] = true;
        this.selectInstance = $(this.selectEl).select2(settings);

        this.selectInstance.on('select2:select', e => {
            const yearVal = this.selectEl.value;
            this.year = yearVal;
            this.page = null;
            this.loadTableData();
        });
    }

    setPagination() {
        if (!this.paginationEl) return;

        this.paginationInstance = new Pagination(this.paginationEl, this.root);
        this.root.addEventListener('pagination-change', e => {
            const { detail } = e;
            this.page = detail;

            if (this.page < 1) {
                this.page = 1;
                return;
            }

            if (this.page > this.maxPages) {
                this.page = this.maxPages;
                return;
            }

            this.loadTableData();
        });
    }

    async loadTableData() {
        const formData = new FormData();
        formData.append('action', 'analysts_pagination');
        formData.append('post_id', this.postId);

        if (this.page) formData.append('page', this.page);
        if (this.year) formData.append('year', this.year);

        try {
            const req = await fetch(ajax.url, {
                method: 'POST',
                body: formData,
            });

            if (!req) return;

            const { html, page, max_num_pages } = await req.json();

            if (html?.length > 0) {
                this.tableWrapper.innerHTML = html;
                this.maxPages = parseInt(max_num_pages);

                if (this.year) {
                    this.paginationInstance.reset(0, 0);
                    this.paginationInstance.hidePagination();
                } else {
                    this.paginationInstance.reset(
                        page,
                        parseInt(max_num_pages)
                    );
                }
            }
        } catch (error) {
            console.log(`error: ${error}`);
        } finally {
        }
    }
}

const sections = document.querySelectorAll('[data-analysts-table]');
const initAnalystsTables = sections => {
    if (sections) {
        sections.forEach(section => new AnalystsTable(section));
    }
};

initAnalystsTables(sections);
